import { useQuery } from "react-query";

import http from "../../../services/httpService";
import Util from "../../../util/util";
import useRemoteDomain from "../../queryResults/remote/useRemoteDomain";
import useUrls from "../../useUrls";

/**
 *
 * @returns {function(): Promise<*>}
 */
const getTemplates = (domain, apiUrl) => async () => {
  console.log("getTemplates() called...");

  const config = Util.addTokenToHeaders();
  const { data } = await http.get(
    `${apiUrl}/admin/remote/domains/${domain.id}/templates`,
    config
  );

  console.log("getTemplates() response data:");
  console.log(data);

  return data;
};

export default function useQueryRemoteTemplates() {
  const domain = useRemoteDomain();
  const { apiUrl } = useUrls();

  return useQuery(
    ["admin", "remote", "templates", domain?.slug],
    getTemplates(domain, apiUrl),
    {
      enabled: !!localStorage.getItem("token") && !!domain,
    }
  );
}
